module.exports = __webpack_public_path__ + "static/media/photo.244ae70f.svg";